import {
  Button,
  ButtonGroup,
  Checkbox,
  Stack,
  Text,
  VStack,
  Separator,
} from "@chakra-ui/react";
import { t } from "i18next";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useStores } from "../../shared/stores/RootStore";

const RouteCheckBoxBase: React.FC<{
  projectId: string;
}> = ({ projectId }) => {
  const { screenStore } = useStores();
  const [selectedIds, setSelectedIds] = useState(new Set<string>());

  useEffect(() => {
    setSelectedIds(() => new Set(screenStore.selectedWays));
    //eslint-disable-next-line
  }, [screenStore.selectedWays.length]);

  const handleSubmit = () => {
    const finalNodesList = screenStore.waysResponse?.nodes.filter((node) =>
      screenStore.selectedWays.includes(node.name)
    );
    finalNodesList &&
      screenStore.createScreenNodes(projectId, finalNodesList!!);
  };

  return (
    <Stack maxW={"25%"}>
      <VStack alignItems="start" p={5}>
        <Text fontSize={"large"}>{t("screen:screenRouteList.checkList")}</Text>
        <Separator />
        {screenStore.waysResponse?.osaWayNames.map((osaWayName, i) => (
          <Checkbox.Root
            key={i}
            colorPalette="primary"
            name={osaWayName}
            checked={selectedIds.has(osaWayName)}
            onCheckedChange={({ checked }) => {
              setSelectedIds(() => {
                if (checked) {
                  screenStore.addSelectedWay(osaWayName);
                } else {
                  screenStore.removeSelectedRoute(osaWayName);
                }
                return new Set(screenStore.selectedWays);
              });
            }}
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control />
            <Checkbox.Label>
              <Text fontSize="sm" lineClamp={1}>
                {osaWayName}
              </Text>
            </Checkbox.Label>
          </Checkbox.Root>
        ))}
      </VStack>

      <VStack p={5} alignItems={"end"}>
        <ButtonGroup colorPalette="primary" size="sm">
          <Button disabled={!selectedIds.size} onClick={handleSubmit}>
            {t("notification:notificationSettingsModal.submit")}
          </Button>
        </ButtonGroup>
      </VStack>
    </Stack>
  );
};

export const RouteCheckBox = observer(RouteCheckBoxBase);
